import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';

export const useFetchStageHistory = (id: string) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await DealsService.getStagesHistory(id);
        setData(res.data);
      } catch (error) {
        console.error(error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return {
    data,
    loading,
  };
};
